{
    "name": "vetir-web",
    "main": "expo-router/entry",
    "version": "1.0.0",
    "scripts": {
        "start": "expo start",
        "reset-project": "node ./scripts/reset-project.js",
        "android": "expo start --android",
        "ios": "expo start --ios",
        "web": "expo start --web",
        "staging": "NODE_ENV=development expo start --web",
        "prod": "NODE_ENV=production expo start --web",
        "expo-clear-cache": "rm -rf .expo .expo/web/cache && expo start --clear",
        "export-staging": "rm -rf .expo/web/cache && NODE_ENV=development && npx expo export -p web",
        "export-prod": "rm -rf .expo/web/cache && NODE_ENV=production && npx expo export -p web",
        "export-sourcemap-prod": "./build_sourcemap_prod.sh",
        "export-sourcemap-stag": "./build_sourcemap_stag.sh",
        "lint": "expo lint",
        "clean": "npx expo start --clear",
        "postinstall": "patch-package"
    },
    "jest": {
        "preset": "jest-expo"
    },
    "dependencies": {
        "@expo/vector-icons": "^14.0.2",
        "@react-native-async-storage/async-storage": "1.23.1",
        "@react-native-community/netinfo": "^11.4.0",
        "@react-native-firebase/analytics": "^21.2.0",
        "@react-native-firebase/app": "^21.2.0",
        "@react-navigation/native": "^6.0.2",
        "@react-oauth/google": "^0.12.1",
        "@reduxjs/toolkit": "^2.2.7",
        "@sentry/browser": "^8.37.1",
        "@sentry/cli": "^2.38.2",
        "@sentry/react-native": "^5.35.0",
        "@shopify/flash-list": "^1.7.1",
        "axios": "^1.7.7",
        "crypto-js": "^4.2.0",
        "deepmerge": "^4.3.1",
        "expo": "^52.0.25",
        "expo-av": "~15.0.1",
        "expo-clipboard": "^6.0.3",
        "expo-constants": "~16.0.2",
        "expo-font": "~12.0.9",
        "expo-image-picker": "^15.0.7",
        "expo-linear-gradient": "^13.0.2",
        "expo-linking": "~6.3.1",
        "expo-router": "~3.5.23",
        "expo-splash-screen": "~0.27.5",
        "expo-status-bar": "~1.12.1",
        "expo-system-ui": "~3.0.7",
        "expo-video": "^2.0.0",
        "expo-web-browser": "~13.0.3",
        "firebase": "^11.0.0",
        "firebase-tools": "^13.22.1",
        "i18next": "^23.15.1",
        "load-script": "^2.0.0",
        "moment": "^2.30.1",
        "moti": "^0.27.2",
        "react": "18.2.0",
        "react-apple-login": "^1.1.6",
        "react-cropper": "^2.3.3",
        "react-dom": "18.2.0",
        "react-drag-drop-files": "^2.4.0",
        "react-helmet": "^6.1.0",
        "react-i18next": "^15.0.2",
        "react-native": "0.74.5",
        "react-native-device-info": "^13.0.0",
        "react-native-fast-image": "^8.6.3",
        "react-native-gesture-handler": "~2.18.1",
        "react-native-imask": "^7.6.1",
        "react-native-localize": "^3.2.1",
        "react-native-markdown-display": "^7.0.2",
        "react-native-mask-input": "^1.2.3",
        "react-native-permissions": "^5.2.4",
        "react-native-reanimated": "^3.15.2",
        "react-native-reanimated-carousel": "4.0.0-alpha.8",
        "react-native-safe-area-context": "4.10.5",
        "react-native-screens": "3.31.1",
        "react-native-svg": "^15.7.1",
        "react-native-toast-notifications": "^3.4.0",
        "react-native-video": "^6.8.2",
        "react-native-walkthrough-tooltip": "^1.6.0",
        "react-native-web": "~0.19.10",
        "react-redux": "^9.1.2",
        "redux": "^5.0.1",
        "redux-persist": "^6.0.0",
        "redux-thunk": "^3.1.0"
    },
    "devDependencies": {
        "@babel/core": "^7.20.0",
        "@babel/plugin-proposal-export-namespace-from": "^7.18.9",
        "@babel/plugin-transform-block-scoping": "^7.25.0",
        "@types/jest": "^29.5.12",
        "@types/react": "~18.2.45",
        "@types/react-test-renderer": "^18.0.7",
        "babel-plugin-module-resolver": "^5.0.2",
        "eslint": "^8.57.0",
        "eslint-config-expo": "~7.1.2",
        "jest": "^29.2.1",
        "jest-expo": "~51.0.3",
        "patch-package": "^8.0.0",
        "postinstall-postinstall": "^2.1.0",
        "react-test-renderer": "18.2.0",
        "typescript": "~5.3.3"
    },
    "private": true
}
